module.exports = __webpack_public_path__ + "img/signout.fbbe59c6.svg";